import { ApiService } from '~/shared/api'
import { restGetList } from '~/shared/utils/decorators'
import type { ServiceRestGetList, UnknownObject } from '~/shared/interfaces'
import { VacancyInterlinksModel } from '~/model/Vacancy'
import { InterlinksFiltersParams } from '~/interfaces/Filters'

interface VacanciesInterlinksService extends ServiceRestGetList {}

@restGetList
// eslint-disable-next-line no-redeclare
class VacanciesInterlinksService extends ApiService {
  protected route: string = 'vacancies/interlink-filters'

  getListModel(params: InterlinksFiltersParams = {}): Promise<Array<VacancyInterlinksModel>> {
    return this.getList(params as UnknownObject)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          return data.map(item => new VacancyInterlinksModel(item))
        }
        return []
      })
      .catch(() => [])
  }
}

export default VacanciesInterlinksService
